export const registrationModal = {
  invoke: {
    src: 'watchRegisterModalActions',
    cond: 'isHeaderInVisibleMode',
  },
};
